import { X, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useVersionCheck } from '@/hooks/useVersionCheck';
import { useI18n } from '@/hooks/useI18n';

/**
 * Version update banner.
 *
 * Uses the useVersionCheck hook to detect new deployments.
 * When a new version is available, displays a fixed banner at the
 * bottom of the screen prompting the user to reload.
 */
export function VersionChecker() {
  const { hasUpdate, dismiss } = useVersionCheck();
  const { t } = useI18n();

  if (!hasUpdate) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-primary-600 text-white px-4 py-3 shadow-lg">
      <div className="container mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm">
          <RefreshCw className="h-4 w-4 flex-shrink-0" />
          <span>{t('common.versionUpdate')}</span>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            size="sm"
            variant="secondary"
            onClick={() => window.location.reload()}
            className="text-xs"
          >
            {t('common.refreshNow')}
          </Button>
          <button
            onClick={dismiss}
            className="text-white/80 hover:text-white transition-colors"
            aria-label={t('common.close')}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
